import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  CircularProgress,
  TextField,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Scrollbar from "../components/scrollbar";
import Iconify from "src/components/iconify/Iconify";
import { useNavigate } from "react-router-dom";
import PackSettingsDialog from "src/components/packs-admin/PackSettingsDialog";
import { nhlPackTypes } from "src/utils/cardUtils";
import { get, post } from "src/utils/networkUtils";
import PackStatWidget from "src/components/packs-admin/PackStatWidget";
import PacksTable from "src/components/packs-admin/PacksTable";

export default function PacksDashboardPage() {
  const navigate = useNavigate();
  const [scoreablesStats, setScoreablesStats] = useState(null);
  const [packs, setPacks] = useState(null);
  const [competitions, setCompetitions] = useState(null);
  const [packTypes, setPackTypes] = useState(null);
  const [editPack, setEditPack] = useState(null);
  const [competitionId, setCompetitionId] = useState(1);
  const [loading, setLoading] = useState(false);
  const [generateParams, setGenerageParams] = useState({
    Team: 1,
    Defender: 2,
    Midfielder: 2,
    Forward: 2,
    Random: 8,
    Gold: 1,
    Silver: 2,
    Base: 0,
    Blue: 0,
    AllRounder: 0,
    Position: 0,
  });
  const [totalCard, setTotalCard] = useState(0);

  useEffect(() => {
    get(`/admin/cards/stats`).then(function (response) {
      setScoreablesStats(response.stats);
    });
    get(`/admin/packs`).then(function (response) {
      setPacks(response.packs);
    });
    get(`/admin/competitions`).then(function (response) {
      setCompetitions(response.competitions);
    });
    get(`/admin/packs/types`).then(function (response) {
      setLoading(false);
      setPackTypes(
        response.packTypes.filter((pack) => nhlPackTypes.includes(pack.value))
      );
    });
  }, []);
  const handleChange = (e) => {
    const { id, value } = e.target;

    setGenerageParams((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const handleGenerateTestPack = (e) => {
    post(`/admin/packs/test-generate`, {
      ratings: {
        Gold: generateParams.Gold,
        Silver: generateParams.Silver,
        Base: generateParams.Base,
        Blue: generateParams.Blue,
      },
      positions: {
        Team: generateParams.Team,
        Defender: generateParams.Defender,
        Midfielder: generateParams.Midfielder,
        Forward: generateParams.Forward,
        Random: generateParams.Random,
      },
      competitionId,
    }).then(function (response) {
      window.location.reload();
    });
  };

  console.log(generateParams);

  useEffect(() => {
    const total =
      +getNumber(generateParams?.Team) +
      getNumber(+generateParams?.Defender) +
      getNumber(+generateParams?.Midfielder) +
      getNumber(+generateParams?.Forward) +
      getNumber(+generateParams?.Random) +
      getNumber(+generateParams?.AllRounder) +
      getNumber(+generateParams?.Possition);

    setTotalCard(total);
  }, [generateParams]);

  const getNumber = (value) => Number(value) || 0;

  return (
    <>
      <Helmet>
        <title> Scoring Entries </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Packs
        </Typography>
        {scoreablesStats === null || loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Grid container spacing={3}>
              <PackStatWidget
                title="GOLD CARDS"
                total={scoreablesStats.goldCount}
                icon="eva:person-done-outline"
                color="warning"
              />
              <PackStatWidget
                title="SILVER CARDS"
                total={scoreablesStats.silverCount}
                icon="eva:person-done-outline"
                color="primary"
              />
              <PackStatWidget
                title="BASE CARDS"
                total={scoreablesStats.baseCount}
                icon="eva:person-done-outline"
                color="error"
              />
            </Grid>
            <Typography variant="h4" sx={{ mb: 1 }}>
              Pack Settings
            </Typography>
            <Typography variant="h7">
              These pack settings are only for packs outside the marketplace
              like welcome, starter, free daily pack.
            </Typography>
            {packTypes === null || loading ? (
              <Box
                sx={{ display: "flex", justifyContent: "center" }}
                style={{ padding: 20 }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <TableContainer component={Paper} sx={{ mt: 3 }}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Pack Name</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {packTypes?.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>

                        <TableCell component="th" scope="row">
                          <Iconify
                            icon={"eva:edit-outline"}
                            sx={{ cursor: "pointer" }}
                            onClick={() => setEditPack(row.value)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            <Typography variant="h4" sx={{ mb: 5, mt: 2 }}>
              Generate Test Pack
            </Typography>
            <Grid container>
              <Grid item xs={6} sx={{ mt: 0 }}>
                <Grid container>
                  <Grid item xs={12} sx={{ mt: 0, p: 1 }}>
                    Number of Cards: {totalCard}
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="Gold"
                      label="Gold"
                      fullWidth
                      value={generateParams.Gold}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="Silver"
                      label="Silver"
                      fullWidth
                      value={generateParams.Silver}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="Base"
                      label="Base"
                      fullWidth
                      value={generateParams.Base}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="Blue"
                      label="Blue"
                      fullWidth
                      value={generateParams.Blue}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="Team"
                      label="Team"
                      fullWidth
                      value={generateParams.Team}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="Defender"
                      label="Defender"
                      fullWidth
                      value={generateParams.Defender}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="Midfielder"
                      label="Midfielder"
                      fullWidth
                      value={generateParams.Midfielder}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="Forward"
                      label="Forward"
                      fullWidth
                      value={generateParams.Forward}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="Random"
                      label="Random"
                      fullWidth
                      value={generateParams.Random}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="AllRounder"
                      label="All Rounder"
                      fullWidth
                      value={generateParams.AllRounder}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ m: 0, p: 1 }}>
                    <TextField
                      id="Position"
                      label="correlating soccer position"
                      fullWidth
                      value={generateParams.Position}
                      variant="standard"
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={9} sx={{ m: 0, p: 1 }}>
                    <FormControl sx={{ m: 1, minWidth: 320 }} size="small">
                      <InputLabel id="demo-simple-select-label">
                        Competition
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={competitionId}
                        label="Competition"
                        onChange={(event) =>
                          setCompetitionId(event.target.value)
                        }
                      >
                        {competitions?.map((competition, index) => (
                          <MenuItem
                            value={competition.id}
                            key={`competition-${competition.id}`}
                          >
                            {competition.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sx={{ m: 0, p: 1 }}>
                    <Button
                      onClick={() => handleGenerateTestPack()}
                      variant="contained"
                      endIcon={
                        <Iconify
                          icon={"eva:person-done-outline"}
                          width={24}
                          height={24}
                        />
                      }
                    >
                      Generate Pack
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={6} sx={{ mt: 2 }}>
                {packs === null || loading ? (
                  <Box
                    sx={{ display: "flex", justifyContent: "center" }}
                    style={{ padding: 20 }}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <Scrollbar>
                    <PacksTable packs={packs} navigate={navigate} />
                  </Scrollbar>
                )}
              </Grid>
            </Grid>
          </>
        )}
      </Container>
      {editPack !== null && (
        <PackSettingsDialog
          packType={editPack}
          open={editPack !== null}
          onSuccessHandler={() => setEditPack(null)}
          onClose={() => setEditPack(null)}
        />
      )}
    </>
  );
}
